export default "__VITE_ASSET__CKb8sqZW__"